import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import intl from 'react-intl-universal';
import Box from '@mui/material/Box';
import CustomerListResults from './CustomerListResults';
import CheckRefresh from '../CheckRefresh';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
class RecordingsDash extends Component {

    render () {  
        const { userrights } = this.props
        let hostmail = (cookies.get('hostmail'))
        let direktdate = (cookies.get('direktdate'))
        
        
        return (
            <Fragment>
            <CheckRefresh />
            <Box  sx={{ p: 2, border: '1px dashed grey' }}>
              <h1>{intl.get('RECORDINGS')}</h1>
              <p>{intl.get('DASH_RECORDINGS_DESC')}</p>
              <hr />
                 <CustomerListResults apitoken={this.props.apitoken} userrights={userrights}  hostmail={hostmail} direktdate={direktdate} />
            </Box>
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken,
    userrights: state.getuserdata.userrights
  });


export default connect(mapStateToProps)(RecordingsDash);
